/**
 * ConcoursBF — Candidate self-service API.
 */
import apiClient from './apiClient';

export async function updateUser(id, updates) {
  return apiClient(`/users/${id}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  });
}

export async function exportUser(id) {
  return apiClient(`/users/${id}/export`);
}

export async function requestDeletion(id, reason = '') {
  return apiClient(`/users/${id}`, {
    method: 'DELETE',
    body: JSON.stringify({ reason }),
  });
}
